import React from "react";
import Header from "../components/Header"; // The public header
import Footer from "../components/Footer";

const PublicLayout = ({ children }) => {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
};

export default PublicLayout;
